.unicode {
  unicode-bidi: plaintext;
}